import React from 'react';
import { Divider, Typography } from "../../ecosystem/";

export const InHomePatientNameHeading = ({
    className,
    patientName,
    subText
}) => {

    return (<>
        <div className={`row in-home-patient-name-heading-container ${className ? className : ''}`}>
            <div className="col-12 in-home-patient-name-heading__name">
                <Typography
                    tag="h2"
                    type={"body-02"}
                    color="$color-primary-a2"
                    bold
                >
                    {patientName}
                </Typography>
            </div>
            {subText &&
                <div className="col-12 in-home-patient-name-heading__subtext">
                    <Typography
                        type={"body-01"}
                    >
                        {subText}
                    </Typography>
                </div>

            }
        </div>
    </>);
}

